<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="banner.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Действует с</label>
            <crm-datepicker
              [(value)]="banner.start"
              [inputStyleClass]="errors?.start ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.start"
              class="p-error">
              {{ errors.start | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Действует до</label>
            <crm-datepicker
              [(value)]="banner.end"
              [inputStyleClass]="errors?.end ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.end"
              class="p-error">
              {{ errors.end | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Описание</label>
            <crm-editor
              [(value)]="banner.text"
              height="110px"></crm-editor>
            <small
              *ngIf="errors?.text"
              class="p-error">
              {{ errors.text | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Цвет</label>
            <div class="flex align-items-end gap-3">
              <crm-color-picker [(color)]="banner.color"></crm-color-picker>
              <div
                style="width: 50px; height: 50px; border-radius: 5px"
                [ngStyle]="{ 'background-color': banner.color }"></div>
            </div>
            <div class="p-inputgroup crm-hex-inputgroup mt-2">
              <span class="p-inputgroup-addon">Hex</span>
              <crm-input-text
                [value]="banner.color"
                (valueChange)="changeColor($event)"
                [isError]="$any(errors?.color)"
                class="w-full"></crm-input-text>
            </div>

            <small
              *ngIf="errors?.color"
              class="p-error">
              {{ errors.color | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Клиенты</label>
            <crm-client-multi-select
              [(selectedClients)]="banner.clients"
              [isFloatLabel]="false"
              [isError]="$any(errors?.clients)"
              appendTo="body"></crm-client-multi-select>
            <small
              *ngIf="errors?.clients"
              class="p-error">
              {{ errors.clients | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Помещения</label>
            <crm-room-multi-select
              [(selectedRooms)]="banner.rooms"
              [onlyWithEquipment]="true"
              [isFloatLabel]="false"
              [isError]="$any(errors?.rooms)"
              appendTo="body"></crm-room-multi-select>
            <small
              *ngIf="errors?.rooms"
              class="p-error">
              {{ errors.rooms | join }}
            </small>
          </div>

          <div
            *ngIf="banner.deleted"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удален"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit"
        class="mt-3">
        <crm-banner-history [index]="index"></crm-banner-history>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <div
      *ngIf="(form$ | async)?.canWrite"
      class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success mr-2"
        (onClick)="saveBanner()"></crm-button>

      <ng-container *ngIf="(form$ | async)?.isShowDelete">
        <crm-button
          *ngIf="!banner.deleted"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteBanner()"></crm-button>

        <crm-button
          *ngIf="banner.deleted"
          label="Восстановить"
          styleClass="p-button-text"
          (onClick)="restoreBanner()"></crm-button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
